import React from "react";
import { useHistory } from "react-router-dom";

import { isStringUuid } from "src/utils/methods";
import ActivateResearchProjectPane from "./ActivateResearchProjectPane";
import { GlobalTaskDetails } from "src/app/components/GlobalTaskDetails/GlobalTaskDetails";

interface CreatorSearchPanesProps {
  isActivateProjectPaneOpen: boolean;
  projectId: string;
  handleCloseActivateProjectPane: () => void;
}

export default function CreatorSearchPanes({
  isActivateProjectPaneOpen,
  projectId,
  handleCloseActivateProjectPane,
}: CreatorSearchPanesProps) {
  const history = useHistory();
  const urlSearchParams = new URLSearchParams(history.location.search);
  const showGlobalTask = isStringUuid(
    urlSearchParams.get("displayGlobalTask") || "",
  );
  return (
    <>
      {isActivateProjectPaneOpen && (
        <ActivateResearchProjectPane
          onClose={handleCloseActivateProjectPane}
          projectId={projectId}
        />
      )}
      {showGlobalTask && <GlobalTaskDetails />}
    </>
  );
}
